/** @format */

import Vue from "vue";
import Vuex from "vuex";
import auth from "./auth.module";
import general from "./general.module";
import events from "./events.module";
import hotels from "./hotels.module";
import seatsio from "./seatsio.module";
import payments from './payments.module'
import occasions from './occasion.module'
import spark from './spark.module'
import externalSite from './externalSite.module'
import flight from './flight.module'
import blogs from './blogs.module'
import tixstock from './tixstock.module'




Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    general,
    events,
    seatsio,
    hotels,
    payments,
    occasions,
    spark,
    externalSite,
    flight,
    blogs,
    tixstock
  },
});
